<div class="relative">
  <div class="side flex" [ngClass]="classList()">
    <div class="m-0.5 flex gap-1">
      @for (t of side().teeth; track t.id) {
        <lib-perio-position-indicator-tooth [toothStatus]="t.status" (toothClick)="onToothClick(t)"></lib-perio-position-indicator-tooth>
      }
    </div>
  </div>
</div>
